import router from '@/router'
import { filterMenuRoutesByPerm } from '@/utils/managementNavigation.cjs'
const {
  isPlatformSuperAdmin,
  isProjectManager: isProjectManagerUser,
  isSpaceAdmin: isSpaceAdminUser
} = require('@/utils/roomAccessUi.cjs')

// 物联业务中心静态菜单（侧边栏展示用，实际路由已在 constantRoutes 中注册）。
// 业务能力按用户的日常任务分组，不再把设备、数据、自动化和运维平铺在“IoT管理”下。
const iotMenuRoutes = [
  {
    path: '/iot/device-access',
    meta: { title: '设备接入', icon: 'el-icon-connection' },
    children: [
      { path: '/iot/device',        meta: { title: '设备管理', icon: 'el-icon-cpu',             perm: 'device', projectUserOnly: true } },
      { path: '/iot/template',      meta: { title: '设备模板', icon: 'el-icon-files',           perm: 'device', projectManagerOnly: true } },
      { path: '/iot/grant-manage',  meta: { title: '扫码权限', icon: 'el-icon-key',             perm: 'device', projectManagerOnly: true } },
      { path: '/iot/qr-print',      meta: { title: '设备二维码', icon: 'el-icon-picture-outline', perm: 'device', projectManagerOnly: true } },
      { path: '/iot/ota',           meta: { title: 'OTA固件', icon: 'el-icon-upload2',           perm: 'ota', projectManagerOnly: true } }
    ]
  },
  {
    path: '/iot/data-analysis',
    meta: { title: '数据分析', icon: 'el-icon-data-analysis' },
    children: [
      { path: '/iot/data',   meta: { title: '数据监控', icon: 'el-icon-data-line',     perm: 'monitor', projectUserOnly: true } },
      { path: '/iot/forecast', meta: { title: 'AI预测中心', icon: 'el-icon-magic-stick', perm: 'monitor', projectManagerOnly: true } },
      { path: '/iot/metric', meta: { title: '指标管理', icon: 'el-icon-odometer',      perm: 'monitor', projectManagerOnly: true } },
      { path: '/iot/board',  meta: { title: '数据看板', icon: 'el-icon-data-analysis', perm: 'monitor', projectManagerOnly: true } }
    ]
  },
  {
    path: '/iot/automation-center',
    meta: { title: '自动化控制', icon: 'el-icon-magic-stick' },
    children: [
      { path: '/iot/point-strategies', meta: { title: '点位策略', icon: 'el-icon-coordinate', perm: 'device', projectManagerOnly: true } },
      { path: '/iot/automation', meta: { title: '策略管理', icon: 'el-icon-s-operation', perm: 'device', projectUserOnly: true } },
      { path: '/iot/scheduler', meta: { title: '定时任务', icon: 'el-icon-time', perm: 'device', projectUserOnly: true } },
      { path: '/iot/calendars', meta: { title: '假期日历', icon: 'el-icon-date', perm: 'device', projectManagerOnly: true } },
      { path: '/iot/strategy', meta: { title: '策略引擎', icon: 'el-icon-magic-stick', perm: 'device', projectUserOnly: true } }
    ]
  },
  {
    path: '/iot/operations',
    meta: { title: '告警运维', icon: 'el-icon-warning-outline' },
    children: [
      { path: '/iot/alert',         meta: { title: '告警管理', icon: 'el-icon-warning',    perm: 'alert', projectUserOnly: true } },
      { path: '/iot/workorder',     meta: { title: '工单管理', icon: 'el-icon-tickets',    perm: 'workorder', projectManagerOnly: true } },
      { path: '/iot/asset',         meta: { title: '设备台账', icon: 'el-icon-notebook-2', perm: 'asset', projectUserOnly: true } },
      { path: '/iot/commissioning', meta: { title: '安装核验', icon: 'el-icon-circle-check', perm: 'commissioning', projectManagerOnly: true } }
    ]
  },
  // AI 助手：点击不在应用内跳转，而是新标签页打开独立整页 /assistant（newWindow 标记，见 SidebarItem）。
  { path: '/iot/ai', meta: { title: 'AI助手', icon: 'el-icon-chat-dot-round', newWindow: '/assistant', projectUserOnly: true } },
  // 停车管理（车辆通行）—— 暂不接入细分后端权限，但只对已识别的项目角色可见
  // 注：和 IoT 管理同属 /iot 顶层分组（被 layout 的 currentTop 过滤逻辑捕获），
  // 故 path 写成 '/iot/parking'，子项使用绝对路径避免拼接错位。
  {
    path: '/iot/parking',
    meta: { title: '停车管理', icon: 'el-icon-truck', projectUserOnly: true },
    children: [
      { path: '/iot/parking/dashboard', meta: { title: '数据概览', icon: 'el-icon-data-analysis' } },
      { path: '/iot/parking/records',   meta: { title: '出入查询', icon: 'el-icon-document-copy' } },
      { path: '/iot/parking/vehicles',  meta: { title: '车辆管理', icon: 'el-icon-truck' } },
      { path: '/iot/parking/spaces',    meta: { title: '车位管理', icon: 'el-icon-s-grid' } },
      { path: '/iot/parking/monthly',   meta: { title: '月卡管理', icon: 'el-icon-postcard' } },
      { path: '/iot/parking/payments',  meta: { title: '缴费查询', icon: 'el-icon-money' } }
    ]
  },
  {
    path: '/iot/property',
    meta: { title: '物业管理', icon: 'el-icon-office-building', projectUserOnly: true },
    children: [
      { path: '/iot/property/dashboard', meta: { title: '物业概览', icon: 'el-icon-data-analysis' } },
      { path: '/iot/property/owners',    meta: { title: '业主管理', icon: 'el-icon-user-solid' } },
      { path: '/iot/property/units',     meta: { title: '房产管理', icon: 'el-icon-house' } },
      { path: '/iot/property/bills',     meta: { title: '物业账单', icon: 'el-icon-document' } },
      { path: '/iot/property/repairs',   meta: { title: '报修工单', icon: 'el-icon-set-up' } }
    ]
  },
  {
    path: '/iot/energy',
    meta: { title: '能耗管理', icon: 'el-icon-lightning', projectUserOnly: true },
    children: [
      { path: '/iot/energy/dashboard',   meta: { title: '能耗概览', icon: 'el-icon-data-analysis' } },
      { path: '/iot/energy/electricity', meta: { title: '用电监控', icon: 'el-icon-lightning' } },
      { path: '/iot/energy/water',       meta: { title: '用水监控', icon: 'el-icon-coin' } },
      { path: '/iot/energy/reports',     meta: { title: '能耗报表', icon: 'el-icon-document-copy' } }
    ]
  },
  {
    path: '/iot/carbon',
    meta: { title: '碳管理', icon: 'el-icon-data-analysis', projectUserOnly: true },
    children: [
      { path: '/iot/carbon/dashboard', meta: { title: '碳排放分析', icon: 'el-icon-data-analysis' } }
    ]
  },
  {
    path: '/iot/info',
    meta: { title: '信息发布', icon: 'el-icon-bell', projectUserOnly: true },
    children: [
      { path: '/iot/info/notices',   meta: { title: '通知公告', icon: 'el-icon-bell' } },
      { path: '/iot/info/screens',   meta: { title: '屏幕设备', icon: 'el-icon-monitor' } },
      { path: '/iot/info/materials', meta: { title: '素材库',   icon: 'el-icon-picture' } },
      { path: '/iot/info/tasks',     meta: { title: '发布任务', icon: 'el-icon-promotion' } }
    ]
  },
  {
    path: '/dcim',
    meta: { title: '数据中心 DCIM', icon: 'el-icon-cpu', projectUserOnly: true },
    children: [
      { path: '/dcim/room3d',   meta: { title: '3D 数据机房', icon: 'el-icon-box', newWindow: '/dcim/room3d' } },
      { path: '/dcim/overview', meta: { title: 'DCIM 总览', icon: 'el-icon-data-analysis' } },
      { path: '/dcim/racks',    meta: { title: '机柜 / U位', icon: 'el-icon-s-grid' } },
      { path: '/dcim/env',      meta: { title: '动环监控', icon: 'el-icon-odometer' } },
      { path: '/dcim/pue',      meta: { title: 'PUE 能效', icon: 'el-icon-lightning' } },
      { path: '/dcim/assets',   meta: { title: '资产 / 容量', icon: 'el-icon-files' } },
      { path: '/dcim/screen',   meta: { title: 'DCIM 大屏', icon: 'el-icon-monitor', newWindow: '/dcim/screen' } }
    ]
  }
]

const commerceConsoleRoutes = [
  {
    path: '/console',
    meta: { title: '项目控制台', icon: 'el-icon-suitcase', projectManagerOnly: true },
    children: [
      { path: '/console/projects', meta: { title: '我的项目申请', icon: 'el-icon-folder-opened', projectManagerOnly: true } }
    ]
  }
]

/**
 * 按当前用户 permissions 过滤 iotMenuRoutes：
 *   - 超管 ('*') 全部可见
 *   - 子菜单 meta.perm 不在用户 permissions 里时隐藏
 *   - 父菜单所有子项被过滤空时，父菜单也不展示
 */
function filterRoutesByProjectRole(routes, userState) {
  const platformSuper = isPlatformSuperAdmin(userState || {})
  const projectManager = isProjectManagerUser(userState || {})
  const projectUser = projectManager || isSpaceAdminUser(userState || {})
  return (routes || []).reduce((result, route) => {
    const meta = route.meta || {}
    if (meta.platformSuperOnly && !platformSuper) return result
    if (meta.projectManagerOnly && !projectManager) return result
    if (meta.projectUserOnly && !projectUser) return result
    const next = { ...route }
    if (route.children) {
      next.children = filterRoutesByProjectRole(route.children, userState)
      if (!next.children.length) return result
    }
    result.push(next)
    return result
  }, [])
}

function filterIotMenuByPerm(perms, userState) {
  return filterRoutesByProjectRole(filterMenuRoutesByPerm(iotMenuRoutes, perms), userState)
}

const systemStaticMenus = {
  resources: [
    { path: '/system/scene', meta: { title: '场景库', icon: 'el-icon-film', projectManagerOnly: true } },
    { path: '/system/product', meta: { title: '产品管理', icon: 'el-icon-goods', projectManagerOnly: true } }
  ],
  integration: [
    { path: '/system/open', meta: { title: '北向集成', icon: 'el-icon-share', projectManagerOnly: true } }
  ]
}

function canAccessSystem(perms) {
  const list = perms || []
  return list.includes('*') || list.some(code => code === 'system' || code.startsWith('system:'))
}

function normalizeSystemChild(route) {
  if (!route) return route
  const path = String(route.path || '')
  return { ...route, path: path.startsWith('/') ? path : `/system/${path}` }
}

// 平台管理只负责全局、低频配置。动态 RBAC 菜单继续负责实际路由注册，
// 这里只重组侧栏信息架构，避免“系统管理”与“IoT管理”两组平铺菜单互相混淆。
function buildSystemMenuRoutes(accessedRoutes, perms, userState) {
  if (!isPlatformSuperAdmin(userState || {}) || !canAccessSystem(perms)) return []

  const systemRoot = (accessedRoutes || []).find(route => route.path === '/system')
  const dynamicChildren = ((systemRoot && systemRoot.children) || []).map(normalizeSystemChild)
  const take = codes => dynamicChildren.filter(route => codes.includes(route.meta && route.meta.permissionCode))
  const knownCodes = new Set([
    'system:tenant', 'system:user', 'system:dept', 'system:role', 'system:permission',
    'system:log', 'system:desktop-license'
  ])
  const otherChildren = dynamicChildren.filter(route => !knownCodes.has(route.meta && route.meta.permissionCode))

  const groups = [
    {
      path: '/system/organization',
      meta: { title: '人员与组织', icon: 'el-icon-office-building', projectManagerOnly: true },
      children: take(['system:tenant', 'system:user', 'system:dept'])
    },
    {
      path: '/system/access-control',
      meta: { title: '角色与权限', icon: 'el-icon-lock', projectManagerOnly: true },
      children: take(['system:role', 'system:permission'])
    },
    {
      path: '/system/resources',
      meta: { title: '平台资源', icon: 'el-icon-collection', projectManagerOnly: true },
      children: systemStaticMenus.resources
    },
    {
      path: '/system/integration-audit',
      meta: { title: '集成与审计', icon: 'el-icon-connection', projectManagerOnly: true },
      children: [
        ...systemStaticMenus.integration,
        ...take(['system:log', 'system:desktop-license'])
      ]
    }
  ]
  if (otherChildren.length > 0) {
    groups.push({
      path: '/system/other',
      meta: { title: '其他设置', icon: 'el-icon-more', projectManagerOnly: true },
      children: otherChildren
    })
  }
  return groups.filter(group => group.children.length > 0)
}

// 前端组件映射表
const componentMap = {
  'Layout': () => import('@/layout/index.vue'),
  'system/user/index': () => import('@/views/system/user/index.vue'),
  'system/role/index': () => import('@/views/system/role/index.vue'),
  'system/dept/index': () => import('@/views/system/dept/index.vue'),
  'system/permission/index': () => import('@/views/system/permission/index.vue'),
  'system/log/index': () => import('@/views/system/log/index.vue'),
  'system/tenant/index': () => import('@/views/system/tenant/index.vue'),
  'system/desktop-license/index': () => import('@/views/system/desktop-license/index.vue'),
  'iot/device/index': () => import('@/views/iot/device/index.vue'),
  'iot/template/index': () => import('@/views/iot/template/index.vue'),
  'iot/data/index': () => import('@/views/iot/data/index.vue'),
  'iot/forecast/index': () => import('@/views/iot/forecast/index.vue'),
  'iot/alert/index': () => import('@/views/iot/alert/index.vue'),
  'iot/ota/index': () => import('@/views/iot/ota/index.vue'),
  'iot/ai/index': () => import('@/views/iot/ai/index.vue')
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES(state, routes) {
    state.addRoutes = routes
    state.routes = routes
  }
}

const actions = {
  generateRoutes({ commit, rootState }, menus) {
    return new Promise(resolve => {
      const userState = rootState.user || {}
      const accessedRoutes = filterRoutesByProjectRole(convertMenusToRoutes(menus || []), userState)
      // 添加 404 兜底
      accessedRoutes.push({ path: '*', redirect: '/404' })

      // 动态添加路由
      accessedRoutes.forEach(route => {
        router.addRoute(route)
      })

      // 将 IoT 静态菜单合并到侧边栏路由（实际路由已在 constantRoutes 中）
      // 动静两套都按权限过滤后再写入（accessedRoutes 已由后端菜单决定；
      // 静态 iot 菜单由前端按 meta.perm 过滤）
      const perms = userState.permissions || []
      const systemMenuRoutes = buildSystemMenuRoutes(accessedRoutes, perms, userState)
      const projectManager = isProjectManagerUser(userState)
      commit('SET_ROUTES', [
        ...(projectManager ? commerceConsoleRoutes : []),
        ...filterIotMenuByPerm(perms, userState),
        ...systemMenuRoutes,
        ...accessedRoutes.filter(route => route.path !== '/system' && route.path !== '*')
      ])
      resolve(accessedRoutes)
    })
  }
}

/**
 * 将后端返回的菜单树转换为 Vue Router 路由
 */
function convertMenusToRoutes(menus) {
  const routes = []
  for (const menu of menus) {
    if (menu.type !== 'MENU') continue

    const route = {
      path: menu.path || '/' + menu.permissionCode,
      name: menu.permissionCode,
      meta: {
        title: menu.name,
        icon: menu.icon,
        permissionCode: menu.permissionCode,
        ...dynamicRouteRoleMeta(menu.permissionCode)
      }
    }

    // 只有含 MENU 类型子节点才作为父路由（BUTTON/API 子节点不算）
    const menuChildren = (menu.children || []).filter(c => c.type === 'MENU')
    if (menuChildren.length > 0) {
      route.component = componentMap['Layout'] || (() => import('@/layout/index.vue'))
      route.redirect = 'noRedirect'
      route.children = convertMenusToRoutes(menu.children)
    } else {
      // 叶子菜单 → 实际组件
      if (!menu.component) {
        // 没有组件映射的菜单（如IoT子菜单，已由 constantRoutes 注册）跳过动态注册
        continue
      }
      const comp = componentMap[menu.component]
      if (comp) {
        route.component = comp
      } else {
        // 尝试动态加载
        route.component = () => import(`@/views/${menu.component}.vue`).catch(() => import('@/views/404.vue'))
      }
    }

    routes.push(route)
  }
  return routes
}

function dynamicRouteRoleMeta(permissionCode) {
  const code = String(permissionCode || '').trim().toLowerCase()
  if (code === 'system' || code.startsWith('system:')) return { platformSuperOnly: true }
  return { projectUserOnly: true }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
